
module.exports = {
    myHost: {
       'host':'https://api-ams.bitflex.xyz'
    }
};
